import React from 'react';
import UserProfileScreenEnhanced from '../../src/screens/profile/UserProfileScreenEnhanced';

export default function ProfileRoute() {
  return <UserProfileScreenEnhanced />;
}
